import axios from 'axios'
import store from '../store'
import { useToast } from 'vue-toastification';
import socketInstance from "@/services/Socket";
const toast = useToast();

export const sensor = {
  namespaced: true,

  state: {
    url_part: 'sensors',
    url_sensor: 'sensors/info/',
    url_sensors_for_gateway_me: 'mySensors/gateway/',
    url_sensor_attribute: 'sensor/attribute',
    url_sensor_holding_registers: 'sensors/holdingRegisters/',
    url_sensor_update_HR: 'sensors/updateHoldingRegisters',
    url_sensor_get_HR: 'sensors/getHoldingRegisters/',
    url_update_register_to_read : 'sensors/updateRegToRead/',
    url_sensors_overview : 'sensors/overview/',
    url_sensor_ai: 'sensors/ai/',
    id: null,
    reading_registers: [],
    holding_registers: [],
    original_holding_registers: [],
  },
  mutations: {
    setId(state, payload) {
      state.id = payload.id;
    },
    setHoldingRegisters(state, payload) {
      if (state.original_holding_registers.length === 0) {
        state.original_holding_registers = structuredClone(payload);
      }
      state.holding_registers = payload;
    },
    setHoldingRegisterValue(state, payload) {
      let hr = state.holding_registers.find(hr => hr.address == payload.address);
      hr.sensor_data_value = payload.value;
      hr.origin = 'Not saved';
      hr.last_update_user_id = store.state.auth.user.Auth?.system_user_id;
    },
    resetHoldingRegisters(state) {
      state.holding_registers = structuredClone(state.original_holding_registers);
    },
    setReadingRegisters(state, payload) {
      state.reading_registers = payload;
    }
  },
  actions: {
    async setId({ state, commit, dispatch }, payload) {
      // Commit the state update first
      commit('setId', payload);
      // Dispatch the other actions
      await dispatch('findInfo', { id: payload.id });
      await dispatch('findInfoOverview', { id: payload.id });
      state.holding_registers = [];
      state.original_holding_registers = [];
      await dispatch('findSensorHoldingRegisters', { sensor_id: payload.id });
    },

    async findAllForGatewayMe ({rootState, state, commit}, payload) {
      let id = payload.id;
      // console.log('find all sensors for gateway ' + id);
      let url = rootState.settings.api_base + state.url_sensors_for_gateway_me + id;

      try {
        let rs = await axios.get(url);
        // console.log('found sensors list for gateway ' + id, rs.data);
        if (typeof payload !== 'undefined') {
          commit('MyView/addChildrenToChild', {
            listType:payload.listType,
            idx:payload.idx,
            idx2: payload.idx2,
            data: rs.data},
            {root: true}
          )
        }
      } catch (err) { 
        console.error('Failed to load my sensor info for gateway.  Error was ' + id, {err});
      }
    },

    async findInfoOverview({ rootState, state, commit, dispatch }, payload) {
      let url = rootState.settings.api_base + state.url_sensors_overview + payload.id;
      try {
        let rs = await axios.get(url);
        commit('apgList/setList', { listType: "sensor_overview", data: rs.data.Attributes},{root: true});
        commit('apgList/setList', { listType: "gateway_overview", data: rs.data.GatewayAttributes},{root: true});
        await dispatch('getRegisters');
      } catch (err) {
        console.error(`Failed to load sensor overview.  Error was ${err}`);
      }
    },

    async insertHoldingRegisters({rootState, state}, payload) {
      // console.log('updating holding register for ' + payload.sensorId + ' for holding_register_id ' + payload.holding_registers_id + ' having value = ' + payload.value)
      let url = rootState.settings.api_base + state.url_sensor_holding_registers + payload.sensorId + '/' + payload.holding_registers_id + '/' + payload.value;

      try {
        let rs = await axios.get(url);
        if( typeof rs === 'undefined' ) {
          // console.log('Failed to insert holding register value for sensor' + payload.sensorId + ' rs was undefined.')
          console.error("The holding register could not be updated for this sensor.");
          return
        } 
        // console.log('updated holding register for ' + payload.sensorId, rs.data)
        toast.success('Holding register updated successfully!');
      } catch (err) {
        toast.error('Failed to update holding register.');
        console.error('Failed to load sensor info for: ' + state.id + ' ERROR: ',{err})
      }
    },

    async updateSensorNewHoldingRegisters({rootState, state, dispatch}) {
      let notSaved = state.holding_registers.filter(hr => hr.origin === 'Not saved');
      let url = rootState.settings.api_base + state.url_sensor_update_HR;
      try {
        let rs = await axios.post(url, {
          holding_registers: notSaved,
          sensor_id: state.id
        });
        if (rs.status === 200) {
          await dispatch('MyView/click', {id: state.id, level: 'sensor'}, {root: true});
          toast.success('Holding register message queued successfully!');
        } else {
          toast.error('Failed to queue holding register message. Please try again.');
          console.error('Failed to update sensor holding regs for: ' + state.id + ' ERROR: ', {rs});
        }
      } catch (err) {
        console.error('Failed to update sensor holding regs for sensor ID: ' + state.id + ' ERROR: ', {err});
      }
    },

    async findSensorHoldingRegisters({rootState, state, commit}, payload) {
      let url = rootState.settings.api_base + state.url_sensor_get_HR + payload.sensor_id;
      try {
        let rs = await axios.get(url);
        if (rs == null) {
          console.error('Failed to find sensor info for sensor ' + state.id + ' rs was undefined.');
          return;
        } 
        // console.log('Found sensor info for sensor ' + state.id, rs.data);
        if (rs.data != null) {
          commit('setHoldingRegisters', rs.data);
        }
      } catch (err) { 
        console.error('Failed to find holding regs for sensor: ' + state.id + ' ERROR: ', {err});
      }
    },

    async findInfo({rootState, state, commit, dispatch}, payload) {
      let id = payload?.id ?? state.id;
      // console.log('finding sensor info for sensor ' + id);

      let url = rootState.settings.api_base + state.url_sensor + id;
      // console.log('url with date range added is: ', url);

      try {
        let rs = await axios.get(url);
        // console.log('rs is ', rs)
        if (rs == null) {
          // console.log('Failed to find sensor info for sensor ' + id + ' rs was undefined.')
          return
        }
        // console.log('found sensor info for sensor ' + id, rs.data)
        if (rs.data) {
          await commit('apgList/setList', {listType: 'sensor_info',data:rs.data.Info[0]}, {root: true});
          await commit('apgList/setList', {listType: 'sensor_attribute',data:rs.data.Attributes}, {root: true});

          // loop through attributes and if one is a dropdown set that value into apgList.
          let attr = rs.data.Attributes
          // console.log('Loading sensor attributes and setting dropdown values', attr)
          for (let i= 0; i < attr.length; i++) {
            if (attr[i].attribute_type == 'dropdown') {
              let table = attr[i]?.attribute_key?.toLowerCase().replace(' ', '_');
              await commit('apgList/setDropdownValue', {
                table,data:attr[i].attribute_value,
                idx:0,
                listType:'sensor_attribute'
              }, {root:true});
            }
          }

          let gateway_id = rs.data.Info[0]['gateway_id'];
          let oldGatewayId = rootState.gateway.id;
          // update gateway data with new id
          await commit('gateway/setId', {id: gateway_id}, {root: true});

          // load alarms if gateway changed or if no alarms loaded yet
          if (oldGatewayId !== gateway_id || rootState.alarm.alarm_set.length === 0) {
            await dispatch('alarm/fetchAlarms', null, {root: true});
          }

          // load the default register on sensor load or the existing register if provided
          let address = rs.data.Attributes.find(a => a.attribute_name === 'addressToRead')?.attribute_value;

          // If no address is set, try to get the first available register
          if (!address) {
            // Get registers for this sensor
            await dispatch('getRegisters');
            // If there are registers available, use the first one as default
            if (state.reading_registers && state.reading_registers.length > 0) {
              address = state.reading_registers[0].address;
              // console.log('No default register found, using first available register:', address);
            }
          }

          await commit('register/setRegisterToRead', {address, upsert: false}, {root: true});

          // Always load a register - either the provided one, the default one, or the first available one
          if (payload.registerAddress != null) {
            await dispatch('register/loadRegister', payload.registerAddress, {root: true});
          } else if (address) {
            await dispatch('register/loadRegister', address, {root: true});
          }

          // set the socket listener for this sensor and register
          socketInstance.sendData('watching_sensor', {sensor_id: id, register: address});
        }
      } catch (err) { 
        console.error('Failed to load my sensor info for: ' + id + ' ERROR: ',{err})
      }
    },

    async getRegisters({rootState, state, commit}) {
      let url = rootState.settings.api_base + state.url_sensor + state.id + '/registers';
      let rs = await axios.get(url);

      if (rs?.status === 200) {
        commit('setReadingRegisters', rs.data);
      } else {
        toast.error('Failed to get sensor registers');
        console.error('getSensorRegisters error:', rs?.data?.error);
      }
    },

    async readAllHoldingRegisters({rootState, state, dispatch}, payload) {
      let sensorId = payload.sensorId;
      let url = rootState.settings.api_base + state.url_sensor_holding_registers + 'readAll';
      // console.log('reading all holding registers for sensor ' + sensorId);
      // console.log('url is ', url);

      let rs = await axios.post(url, {
        sensorId: sensorId,
        powerLine: payload.powerLine || 1,
      });
      // console.log('read all holding registers response', rs);

      if (rs?.status === 200) {
        toast.success('Read All Holding Registers message queued successfully!');
        // refresh sensor info
        await dispatch('findInfo', {
          id: sensorId,
          listType: 'group_gateway_sensor',
          chart: true
        });
        await dispatch('findInfoOverview', {id: sensorId});
      } else {
        toast.error('Failed to queue read all holding registers message. Please try again.');
        // console.error('readAllHoldingRegisters error:', rs?.data?.error);
      }
    }
  },

  getters: {
    id: state => state.id,
    holdingRegistersChanged: state => {
      let original = state.original_holding_registers?.map(hr => hr.sensor_data_value);
      let current = state.holding_registers?.map(hr => hr.sensor_data_value);
      return original?.some((v, i) => v !== current[i]) ?? false;
    },
    individualHrChanged: state => index => {
      let original = state.original_holding_registers[index]?.sensor_data_value;
      let current = state.holding_registers[index]?.sensor_data_value;
      return original !== current ?? false;
    }
  }
}
